// src/components/Footer/Footer.jsx
import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
    const currentYear = new Date().getFullYear(); // Get current year dynamically

    return (
        <footer id="footer" className={styles.footer}>
            <p>Highview Facilities | Church in Atlanta</p>
            <p>© {currentYear} All rights reserved.</p>
        </footer>
    );
};

export default Footer;